


























import { generateStat, ResidentStat } from '@/utils/resident-stat.ts'
import Vue from 'vue'

export default Vue.extend({
  name: 'ResidentStatCard',
  props: {
    patient: {
      type: Object,
      required: true,
    },
    patientWithStats: {
      type: Object,
      default: null,
    },
    patientWithMappingReport: {
      type: Object,
      default: null,
    },
    residentStatType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    residentStat() {
      return generateStat(
        this.patient,
        this.patientWithStats,
        this.patientWithMappingReport,
        this.residentStatType
      ) as ResidentStat
    },
    // if done in template, compiler gives warning
    statusIconSrc() {
      return require(`@/assets/${this.residentStatType.icon}`)
    },
    statStatusIconSrc() {
      return require(`@/assets/${this.residentStat.status.icon}`)
    },
  },
})
